<template>
  <div class="mb-3">
    <label :for="inputId" v-if="label">{{ label }}</label>

    <div class="input-group">
      <div class="input-group-prepend" v-if="hasPrefix">
        <span class="input-group-text">
          <slot name="prefix">{{ prefix }}</slot>
        </span>
      </div>

      <input :id="inputId" :type="inputType" :class="['form-control', hasErrors ? 'is-invalid' : '']" :value="value" @input="updateValue" :disabled="disabled" :placeholder="placeholder" v-if="!multiline" />
      <textarea :id="inputId" :class="['form-control', hasErrors ? 'is-invalid' : '']" :value="value" @input="updateValue" :disabled="disabled" :placeholder="placeholder" :rows="rows" v-if="multiline" />

      <div class="input-group-append" v-if="hasSuffix">
        <span class="input-group-text">
          <slot name="suffix">{{ suffix }}</slot>
        </span>
      </div>
    </div>

    <div :id="errorContainerId" class="invalid-feedback" v-if="hasErrors" v-html="errorMessage"></div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String
    },

    value: {
      required: true
    },

    label: {
      type: String
    },

    disabled: {
      type: Boolean,
      default: false
    },

    errors: {
      default: null
    },

    placeholder: {
      type: String,
      default: ''
    },

    prefix: {
      type: String,
      default: null
    },

    suffix: {
      type: String,
      default: null
    },

    multiline: {
      type: Boolean,
      default: false
    },

    password: {
      type: Boolean,
      default: false
    },

    rows: {
      type: Number,
      default: 4
    }
  },

  data () {
    return {
      inputId: this.id || 'input' + this._uid
    }
  },

  computed: {
    inputType () {
      if (this.password) return 'password'
      return 'text'
    },

    hasPrefix () {
      return this.prefix || this.$slots.prefix
    },

    hasSuffix () {
      return this.suffix || this.$slots.suffix
    },

    errorContainerId () {
      return `${this.inputId}Error`
    },

    hasErrors () {
      return this.errors !== null && this.errors.length > 0
    },

    errorMessage () {
      return this.errors.join('<br>')
    }
  },

  methods: {
    updateValue (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/formFields/eTextInput.vue